import React, {useEffect, useState} 	from 'react';
import PropTypes 						from 'prop-types';
import LangContext 						from '../LangContext';
import langList 						from './../language';
import DataStorage 						from '@Helpers/DataStorage';

/**
 * Translate component
 * @param children
 * @param language
 * @returns {*}
 * @constructor
 */
const Translate = ({children, language = ''}) => {
	useEffect(() => {
		DataStorage.setData('locale', language);
	}, [language]);
	
	const [lang, setLang] = useState(language);

	/**
	 * Set language
	 * @param lang
	 */
	const setLanguage = (lang) => {
		setLang(lang);
		DataStorage.setData('locale', lang);
	};

	/**
	 * Get translate
	 * @param key
	 * @param params
	 * @returns {string|*}
	 */
	const translate = (key, params = {}) => {
		/**
		 * Get object with translates
		 * @returns {{title}}
		 */
		const getTranslateFile = () => {
			return langList?.[lang] ?? {};
		};

		const data = getTranslateFile();

		if (data?.[key]) {
			let t = data[key];

			Object.entries(params).map(([key, value]) => {
				t = t.replace(`:${key}`, value);
			});

			return t;
		}
		
		return `${key} is not define`;
	};

	/**
	 * LangContext value
	 * @type {{language: *, translate: *, setLanguage: *}}
	 */
	const langProvider = {
		language: lang,
		setLanguage,
		translate,
	};

	return (
		<LangContext.Provider value={langProvider}>
			{children}
		</LangContext.Provider>
	);
};

/**
 * PropTypes
 * @type {{children: *, language: *}}
 */
Translate.propTypes = {
	language: PropTypes.string,
	children: PropTypes.any
};

export default Translate;